/**CORE LIBRARIES IMPORT */
import React from "react";

/**COMPONENTS IMPORT */
import BrandLogo from "./BrandLogo";

/**
 * Intentional, branded fallback shown wherever no photograph has been
 * uploaded yet (portal -> Website Media, Menu or Events). Decorative only:
 * the surrounding card already names what it is about.
 */
const PhotoPlaceholder = ({ ratio = "4 / 3", className = "" }) => (
  <div className={`photo-fallback ${className}`} style={{ aspectRatio: ratio }} aria-hidden="true">
    <BrandLogo size={96} decorative className="photo-fallback-logo" />
  </div>
);

export default PhotoPlaceholder;
